import { splitNamespace } from 'stardog-language-utils';
import { alphaSorter } from 'vet-bones/utils';

import { DEFAULT_MODEL } from 'src/templates/queries/iris';

export const getNamedGraphsByModel = (
  reasoningSchemas: string[],
  defaultModelNamedGraphs: string[]
) => {
  const namedGraphsByModel = reasoningSchemas.reduce<Record<string, string[]>>(
    (acc, reasoningSchema) => {
      const [modelName, namedGraph] = splitNamespace(reasoningSchema);
      if (modelName === DEFAULT_MODEL) {
        // ignore any values set for the default reasoning schema here
        // since they're overriden by `reasoning.schema.graphs`
        return acc;
      }

      if (!acc[modelName]) {
        acc[modelName] = [namedGraph];
      } else {
        acc[modelName].push(namedGraph);
      }
      return acc;
    },
    {}
  );

  const models = Object.keys(namedGraphsByModel).sort(alphaSorter);

  models.unshift(DEFAULT_MODEL);
  namedGraphsByModel[DEFAULT_MODEL] = defaultModelNamedGraphs;

  return { namedGraphsByModel, models };
};
